import React from 'react';

import { useHistory } from 'react-router-dom';

import TableHeader from '../../../../components/Table/TableHeader';
import TablePagination from '../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../components/InputSearch'

const tabelaColunas = ['Nome', 'E-mail', 'Status', '']

const PerfilSellerListUsuario = ({ response, buscar, busca, mudarPagina }) => {

    const history = useHistory();

    const changePage = (page) => {
        mudarPagina(page)
    }

    const gotoDet = (userId) => {
        history.push(`/seller/usuario/${userId}`);
    }

    return (
        <div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    response?.lista === 0 &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }

                                {
                                       response?.lista && response?.lista?.map((user) => (
                                        <tr key={user.id}>
                                            <td> {user.nome} </td>
                                            <td> {user.email} </td>
                                            <td> {user.ativo ? 'Ativo' : 'Inativo'} </td>
                                            <td className="text-right">
                                                <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => gotoDet(user.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PerfilSellerListUsuario;